// extracted by mini-css-extract-plugin
export default {"header":"budget_vs_forecast-module___header___e58d9458"};